module.exports = __webpack_public_path__ + "img/llamadas.c3d3c0e5.png";